import Tracker from '~/src/common/services/Tracker';

export const sendFooterNavigationEvent = (navigationText: string) => {
  Tracker.sendEvent('user navigation footer', { 'navigation text': navigationText });
};
